import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postRequestNewTwoFactorCode } from '../../requests/postRequestNewTwoFactorCode';

export const useRequestNewTwoFactorCode = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: () => postRequestNewTwoFactorCode(constructPost),
  });
  return { requestNewTwoFactorCode: mutateAsync, ...rest };
};
